import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';


const employeeAPI = createApi({
    reducerPath: 'employeeAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getEmployees: builder.mutation({
            query: (details) => ({
                url: '/Employer/GetEmployers',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addEmployee: builder.mutation({
            query: (details) => ({
                url: '/Employer/AddEmployer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateEmployee: builder.mutation({
            query: (details) => ({
                url: '/Employer/UpdateEmployer',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteEmployee: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Employer/DeleteEmployer/?id=${details}`),
                method: 'DELETE',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllEmployeeTypes: builder.query({
            query: () => ({
                url: encryptQueryString('/Employer/GetAllEmployerTypes'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getEmployeeByID: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Employer/GetEmployerDetailsByEmployerID/?id=${details}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateEmployerBankruptcy: builder.mutation({
            query: (details) => ({
                url: '/Employer/UpdateEmployerBankruptcyInformation',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUnAssignedAssociations: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Employer/GetUnAssignedCompanyAssociationDetailsByCompanyID/?companyID=${details}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAssignedAssociations: builder.mutation({
            query: (details) => ({
                url: '/Employer/GetAssignedCompanyAssociationsDetailsByCompanyID',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        assignAssociationsToCompany: builder.mutation({
            query: (details) => ({
                url: '/Employer/AssignCompanyAssociationToCompanyID',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        updateCompanyAssociationJoinDate: builder.mutation({
            query: (details) => ({
                url: '/Employer/UpdateCompanyAssociationJoinDate',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteAssignedAssociation: builder.mutation({
            query: ({ companyID, associationID }) => ({
                url: encryptQueryString(`/Employer/DeleteAssignedCompanyAssociations/?companyID=${companyID}&associationID=${associationID}`),
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addComments: builder.mutation({
            query: (details) => ({
                url: '/CompanyComment/AddCompanyComment',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateComments: builder.mutation({
            query: (details) => ({
                url: '/CompanyComment/UpdateCompanyComment',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getComments: builder.mutation({
            query: (details) => ({
                url: '/CompanyComment/GetCompanyComment',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteComments: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CompanyComment/DeleteCompanyComment?companyCommentId=${details}`),
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    }),
})

export const {
    useGetEmployeesMutation,
    useDeleteEmployeeMutation,
    useAddEmployeeMutation,
    useUpdateEmployeeMutation,
    useLazyGetAllEmployeeTypesQuery,
    useLazyGetEmployeeByIDQuery,
    useUpdateEmployerBankruptcyMutation,
    useLazyGetUnAssignedAssociationsQuery,
    useGetAssignedAssociationsMutation,
    useAssignAssociationsToCompanyMutation,
    useDeleteAssignedAssociationMutation,
    useUpdateCompanyAssociationJoinDateMutation,
    useAddCommentsMutation,
    useUpdateCommentsMutation,
    useGetCommentsMutation,
    useDeleteCommentsMutation,
} = employeeAPI;

export default employeeAPI;